export const monthlyCheckboxQuestions = [
  {
    label:
      "Did you receive the necessary support and resources to accomplish your tasks during your first month?",
    name: "supportAndResources",
    options: ["Yes", "No"],
  },
  {
    label:
      "Have you had sufficient opportunities to collaborate with your team and other departments?",
    name: "collaborationOpportunities",
    options: ["Yes", "No"],
  },
  {
    label:
      "Do you feel well-prepared for your role after the onboarding process?",
    name: "wellPreparedForRole",
    options: ["Yes", "No"],
  },
  {
    label:
      "Are there any areas where you would like further clarification about your role?",
    name: "furtherClarificationNeeded",
    options: ["Yes", "No"],
  },
  {
    label:
      "Do you feel comfortable approaching your colleagues or supervisors with questions or concerns?",
    name: "comfortableApproachingOthers",
    options: ["Yes", "No"],
  },
  {
    label: "Have you received log in credentials of WeConnect?",
    name: "receivedWeConnectCredentials",
    options: ["Yes", "No"],
  },
  {
    label: "Have you read and accepted all the policies on WeConnect?",
    name: "acceptedWeConnectPolicies",
    options: ["Yes", "No"],
  },
  {
    label: "Are you regularly filling your timesheet on WeConnect?",
    name: "regularlyFillingTimesheet",
    options: ["Yes", "No"],
  },
  {
    label: "Are your goals submitted and approved by manager on PromptHR?",
    name: "goalsSubmittedOnPromptHR",
    options: ["Yes", "No"],
  },
];

export const monthly_textAreaQuestions = [
  {
    label:
      "Do you have any feedback or suggestions about your onboarding experience or your first month on the job? (If Yes, please suggest)",
    name: "onboardingFeedback",
    rows: 3,
  },
  // {
  //   label: "Overall Rating out of 5 (5 is the highest)",
  //   name: "overallRating",
  // },
];
